import { QuestionnaireAnswerType } from 'components/Assessments/types'
import { ModifierAQuestionnaireItem } from './questionnaire'

// Modifier A section questionnaire answer type mapping
export const MODIFIER_A_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE = {
  [ModifierAQuestionnaireItem.MODIFIER_A_1_QUESTION]: QuestionnaireAnswerType.CODING,
  [ModifierAQuestionnaireItem.MODIFIER_A_1_NOTES]: QuestionnaireAnswerType.STRING,
  [ModifierAQuestionnaireItem.MODIFIER_A_2_QUESTION]: QuestionnaireAnswerType.CODING,
  [ModifierAQuestionnaireItem.MODIFIER_A_2_NOTES]: QuestionnaireAnswerType.STRING,
  [ModifierAQuestionnaireItem.MODIFIER_A_3_QUESTION]: QuestionnaireAnswerType.CODING,
  [ModifierAQuestionnaireItem.MODIFIER_A_3_NOTES]: QuestionnaireAnswerType.STRING,
  [ModifierAQuestionnaireItem.MODIFIER_A_4_QUESTION]: QuestionnaireAnswerType.CODING,
  [ModifierAQuestionnaireItem.MODIFIER_A_4_NOTES]: QuestionnaireAnswerType.STRING
}
